import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

const ProductPreview = ({
  formData,
  imagePreviewUrl,
  hasGstNumber,
  taxableValue,
  gstValue,
  enableIncentive,
  payableValue,
}) => {
  return (
    <Grid item xs={12} md={4}>
      <Box
        sx={{
          border: '1px solid #e8e9f2',
          borderRadius: '12px',
          padding: '18px',
          position: 'sticky',
          top: '16px',
          background: '#fff',
          boxShadow: '0 1px 3px rgba(30,32,60,0.04)',
        }}
      >
        <div style={{ fontWeight: 700, fontSize: '16px', marginBottom: '2px' }}>Product Preview</div>
        <div style={{ fontSize: '12px', color: '#8a8f98', marginBottom: '14px' }}>
          This is how your product will appear.
        </div>

        <Box
          sx={{
            background: 'linear-gradient(135deg, #f3f2fb, #e9ecfa)',
            borderRadius: '8px',
            height: '250px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '12px',
            overflow: 'hidden',
          }}
        >
          {imagePreviewUrl ? (
            <img
              src={imagePreviewUrl}
              alt="Product Preview"
              style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
            />
          ) : (
            <Inventory2OutlinedIcon sx={{ fontSize: 46, color: '#a9aee0' }} />
          )}
        </Box>

        <div style={{ fontWeight: 700, fontSize: '15px', marginBottom: '2px' }}>
          {formData.productName || 'Product Name'}
        </div>
        <div style={{ fontSize: '12px', color: '#6174DD', marginBottom: '10px' }}>
          {formData.category && formData.subcategory
            ? `${formData.category} • ${formData.subcategory}`
            : formData.category || 'Category • Subcategory'}
        </div>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '8px' }}>
          <span style={{ color: '#8a8f98' }}>Pack Size</span>
          <span style={{ fontWeight: 600 }}>
            {formData.volume || 0} {formData.unit}
          </span>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '10px' }}>
          <span style={{ color: '#8a8f98' }}>HSN Code</span>
          <span style={{ fontWeight: 600 }}>{formData.hsnCode || '-'}</span>
        </Box>

        <Box sx={{ borderTop: '1px solid #eee', paddingTop: '10px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '8px' }}>
            <span style={{ color: '#8a8f98' }}>MRP</span>
            <span style={{ fontWeight: 600 }}>₹{Number(formData.sellPrice || 0).toFixed(2)}</span>
          </Box>
          {hasGstNumber && (
            <>
             <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '10px' }}>
                <span style={{ color: '#8a8f98' }}>Taxable Value</span>
                <span style={{ fontWeight: 700, color: '#2e7d32' }}>₹{taxableValue}</span>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '8px' }}>
                <span style={{ color: '#8a8f98' }}>GST</span>
                <span style={{ fontWeight: 600 }}>
                  {formData.GST}% ({formData.taxStatus === 'withTax' ? 'Inclusive' : 'Exclusive'})
                </span>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '10px' }}>
                <span style={{ color: '#8a8f98' }}>Payable Value</span>
                <span style={{ fontWeight: 700, color: '#2e7d32' }}>₹{payableValue}</span>
              </Box>
            </>
          )}
        </Box>

        <Box sx={{ borderTop: '1px solid #eee', paddingTop: '10px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '8px' }}>
            <span style={{ color: '#8a8f98' }}>Stock</span>
            <span style={{ fontWeight: 600 }}>{formData.productCount || 0} units</span>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}>
            <span style={{ color: '#8a8f98' }}>Staff Incentive</span>
            <span style={{ fontWeight: 600, color: '#6174DD' }}>
              {enableIncentive ? `${formData.staffIncentive || 0}${formData.incentiveType === '%' ? '%' : ' ₹'}` : '-'}
            </span>
          </Box>
        </Box>

        <div style={{ fontSize: '11px', color: '#8a8f98', marginTop: '14px' }}>
          Preview updates as you fill the form.
        </div>
      </Box>
    </Grid>
  );
};

export default ProductPreview;